import "../pages.scss"
import { PedidosState } from '../../context/pedidos/PedidosState';
import { PedidosDetalleState } from '../../context/pedidosdetalle/PedidosDetalleState';
import Datatable from "./PedidosTable/Datatable"

const PedidosPage = () => {
  return (
    <>
      <PedidosState>
        <PedidosDetalleState>
          <Datatable />
        </PedidosDetalleState>
      </PedidosState>

    </>
  )
}

export default PedidosPage